const commonConfigs = { loop: !0 },
  configs = {
    mobile: { autoHeight: !0, loop: !0 },
    "quick-view": { autoHeight: !0 },
    "layout-4": {},
    "layout-5": {
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      watchSlidesVisibility: !0,
      breakpoints: {
        768: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 10 },
      },
    },
    "layout-6": {},
    "layout-7": { slidesPerView: 3, speed: 500, centeredSlides: !0 },
  },
  requestDefaultConfigs = {
    mode: "same-origin",
    credentials: "same-origin",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "application/json",
    },
  };
function getRequestDefaultConfigs() {
  return JSON.parse(JSON.stringify(requestDefaultConfigs));
}
function fetchJSON(e, t = getRequestDefaultConfigs()) {
  return fetch(e, t).then(function (e) {
    if (!e.ok) throw e;
    return e.json();
  });
}
const cache = new Map();
function fetchCache(e, t = getRequestDefaultConfigs()) {
  return new Promise((s, n) => {
    let i = cache.get(e);
    if (i) return s(i);
    fetch(e, t)
      .then((t) => {
        (i = t.text()), cache.set(e, i), s(i);
      })
      .catch(n);
  });
}
const sectionCache = new Map();
function fetchSection(e, t = {}) {
  const { url: s, fromCache: n = !1, params: i = {} } = t;
  return new Promise((t, o) => {
    const r = new URL(s || window.location.href);
    if (
      (r.searchParams.set("section_id", e),
      Object.entries(i).forEach(([e, t]) => r.searchParams.set(e, t)),
      n)
    ) {
      const e = sectionCache.get(r);
      if (e) return t(e);
    }
    fetch(r, getRequestDefaultConfigs())
      .then((t) => {
        if (t.ok) return t.text();
        o(`Failed to load section: ${e}`);
      })
      .then((e) => {
        const s = generateDomFromString(e);
        sectionCache.set(r, s), t(s);
      })
      .catch(o);
  });
}
const cache2 = new Map();
function fetchJsonCache(e, t = requestDefaultConfigs) {
  return new Promise((s, n) => {
    if (cache2.get(e)) return s(cache2.get(e));
    fetch(e, t)
      .then((t) => {
        if (t.ok) {
          const n = t.json();
          return s(n), cache2.set(e, n), n;
        }
        n(t);
      })
      .catch(n);
  });
}
function formatMoney(e, t) {
  "string" == typeof e && (e = e.replace(".", ""));
  let s = "";
  const n = /\{\{\s*(\w+)\s*\}\}/,
    i = t || "${{amount}}";
  function o(e, t = 2, s = ",", n = ".") {
    if (isNaN(e) || null == e) return 0;
    const i = (e = (e / 100).toFixed(t)).split(".");
    return (
      i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${s}`) +
      (i[1] ? n + i[1] : "")
    );
  }
  switch (i.match(n)[1]) {
    case "amount":
      s = o(e, 2);
      break;
    case "amount_no_decimals":
      s = o(e, 0);
      break;
    case "amount_with_comma_separator":
      s = o(e, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      s = o(e, 0, ".", ",");
  }
  return i.replace(n, s);
}
function validateForm(e) {
  const t = [];
  if (!e) return t;
  return (
    e
      .querySelectorAll(
        '[data-product-custom-field] [name][required]:not([hidden]):not([type="hidden"])'
      )
      .forEach((s) => {
        if ((s.classList.remove("form-control--warning"), "radio" === s.type)) {
          const n = e.querySelectorAll(`input[name="${s.name}"]`);
          Array.from(n).some((e) => e.checked) ||
            (t.push(s), s.classList.add("form-control--warning"));
        } else s.value || (t.push(s), s.classList.add("form-control--warning"));
      }),
    t
  );
}
function generateDomFromString(e, t = "div") {
  const s = document.createElement(t);
  return (s.innerHTML = e), s;
}
function loadAssetsNew(e = [], t, s = () => {}, n = {}) {
  const i = t || Math.random().toString(36).slice(2);
  window.MinimogLibs.loadjs.isDefined(t) || window.MinimogLibs.loadjs(e, i),
    window.MinimogLibs.loadjs.ready(i, s);
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((e) => {
    e.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}',
      "*"
    );
  }),
    document.querySelectorAll(".js-vimeo").forEach((e) => {
      e.contentWindow.postMessage('{"method":"pause"}', "*");
    }),
    document.querySelectorAll("video").forEach((e) => e.pause()),
    document.querySelectorAll("product-model").forEach((e) => {
      e.modelViewerUI && e.modelViewerUI.pause();
    });
}
function getProductSliderConfig(e) {
  const t = configs[e] || configs["layout-4"];
  return Object.assign({}, commonConfigs, t);
}
function loadJS(e, t = document.body, s = !1, n = !0) {
  return new Promise((i, o) => {
    const r = t.ownerDocument,
      a = r.querySelector(`script[src="${e}"]`);
    if (a)
      return a.dataset.loaded
        ? i(!0)
        : void a.addEventListener("load", () => {
            (a.dataset.loaded = !0), i(!0);
          });
    const c = r.createElement("script");
    (c.src = e),
      (c.async = s),
      (c.defer = n),
      c.addEventListener("load", () => {
        (c.dataset.loaded = !0), i(!0);
      }),
      (c.onerror = o),
      t.appendChild(c);
  });
}
function loadCSS(e, t = document.head) {
  return new Promise((s, n) => {
    const i = t.ownerDocument,
      o = i.querySelector(`link[href="${e}"]`);
    if (o)
      return o.dataset.loaded
        ? s(!0)
        : void o.addEventListener("load", () => {
            (o.dataset.loaded = !0), s(!0);
          });
    const r = i.createElement("link");
    (r.rel = "stylesheet"),
      (r.href = e),
      r.addEventListener("load", () => {
        (r.dataset.loaded = !0), s(!0);
      }),
      (r.onerror = n),
      t.appendChild(r);
  });
}
function addEventDelegate({
  context: e = document.documentElement,
  event: t = "click",
  selector: s,
  handler: n,
  capture: i = !1,
}) {
  const o = function (e) {
    for (let t = e.target; t && t !== this; t = t.parentNode)
      if (t.matches(s)) {
        n.call(t, e, t);
        break;
      }
  };
  return (
    e.addEventListener(t, o, i),
    () => {
      e.removeEventListener(t, o, i);
    }
  );
}
const { themeScriptURLs: themeScriptURLs, themeStyleURLs: themeStyleURLs } =
    window,
  themeAssets = {
    js: { urls: themeScriptURLs, load: loadJS },
    css: { urls: themeStyleURLs, load: loadCSS },
  };
function log(e) {}
function loadAssets(e, ...t) {
  return new Promise((s, n) => {
    const i = "string" == typeof e ? [e] : e;
    Promise.all(
      i.map(async (e) => {
        try {
          const [, s, n] = e.match(/(.*)\.(js|css)$/) || [, e, "js"],
            {
              urls: {
                [s]: { url: i },
              },
              load: o,
            } = themeAssets[n];
          await o(i, ...t), log(`${s}.${n}`);
        } catch (e) {}
      })
    )
      .then(s)
      .catch(n);
  });
}
function queryDomNodes(e = {}, t = document) {
  return Object.entries(e).reduce((e, [s, n]) => {
    const i = "string" == typeof n,
      o = i ? "querySelector" : "querySelectorAll",
      r = i ? n : n[0];
    return (e[s] = t?.[o]?.(r)), !i && e[s] && (e[s] = [...e[s]]), e;
  }, {});
}
class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const e = this.querySelector('[id^="Deferred-Poster-"]');
    e && e.addEventListener("click", this.loadContent.bind(this));
  }
  loadContent(e = !0) {
    if ((window.pauseAllMedia(), !this.getAttribute("loaded"))) {
      const t = document.createElement("div");
      t.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(!0)
      ),
        this.setAttribute("loaded", !0);
      const s = this.appendChild(
        t.querySelector("video, model-viewer, iframe")
      );
      (this.deferredElement = s), e && s.focus();
    }
  }
}
customElements.define("deferred-media", DeferredMedia),
  customElements.get("video-component") ||
    customElements.define(
      "video-component",
      class extends DeferredMedia {
        constructor() {
          super(),
            (this.autoplay = "true" === this?.dataset.autoPlay),
            (this.coverImage = "true" === this?.dataset.coverImage),
            (!this.autoplay && this.coverImage) || this.loadContent();
        }
        loadContent() {
          if ((super.loadContent(), !this.autoplay && this.coverImage)) {
            const e = this.deferredElement?.getAttribute("src"),
              t = e?.indexOf("?") > -1 ? "&" : "?";
            e && this.deferredElement.setAttribute("src", e + t + "autoplay=1");
          }
        }
      }
    );
class QuantityInput extends HTMLElement {
  constructor() {
    super(),
      (this.input = this.querySelector("input")),
      (this.changeEvent = new Event("change", { bubbles: !0 })),
      (this.productId = this.dataset.productId),
      this.querySelectorAll("button").forEach((e) =>
        e.addEventListener("click", this.onButtonClick.bind(this))
      ),
      this.input.addEventListener("change", () => {
        window.MinimogEvents.emit(
          `${this.productId}__QUANTITY_CHANGE`,
          this.input.value,
          this
        );
      });
  }
  onButtonClick(e) {
    e.preventDefault();
    const t = this.input.value;
    "plus" === e.target.closest("button").getAttribute("name")
      ? this.input.stepUp()
      : this.input.stepDown(),
      t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
  }
}
customElements.define("quantity-input", QuantityInput);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    new IntersectionObserver(
      ((e, t) => {
        e[0].isIntersecting &&
          (t.unobserve(this),
          fetch(this.dataset.url)
            .then((e) => e.text())
            .then((e) => {
              const t = generateDomFromString(e).querySelector(
                "product-recommendations"
              );
              if (t && t.innerHTML.trim().length) {
                this.innerHTML = t.innerHTML;
                const e = this.querySelector(".swiper-container"),
                  s = this.dataset.itemsPerPage;
                if (e) {
                  let t;
                  loadAssets(["swiper.css", "swiper.js"]).then(() => {
                    if (
                      ((t = new MinimogLibs.Swiper(e, {
                        slidesPerView: 2,
                        loop: !0,
                        autoplay: !1,
                        breakpoints: { 1280: { slidesPerView: s } },
                      })),
                      t)
                    ) {
                      const e = this.querySelector(".sf-slider__controls-prev"),
                        s = this.querySelector(".sf-slider__controls-next");
                      e && e.addEventListener("click", () => t.slidePrev()),
                        s && s.addEventListener("click", () => t.slideNext());
                    }
                  });
                }
              }
            })
            .catch((e) => {}));
      }).bind(this),
      { rootMargin: "0px 0px 400px 0px" }
    ).observe(this);
  }
}
if (
  (customElements.define("product-recommendations", ProductRecommendations),
  !customElements.get("collapsible-tab"))
) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.init();
    }
    disconnectedCallback() {
      this.destroy();
    }
    init = () => {
      "true" === this.dataset.destroy ||
        (this.setDefaultData(),
        this.attachEvents(),
        "true" === this.getAttribute("open")
          ? ((this.selected = !0),
            this.classList.add(this.expandedClass),
            this.setExpandedAria())
          : ((this.content.style.height = this.collapsedHeight),
            this.classList.add(this.collapsedClass),
            this.setCollapsedAria()),
        this.content.removeAttribute("hidden"));
    };
    transitionendEventName = () => {
      let e,
        t = document.createElement("div"),
        s = {
          transition: "transitionend",
          OTransition: "otransitionend",
          MozTransition: "transitionend",
          WebkitTransition: "webkitTransitionEnd",
        };
      for (e in s)
        if (s.hasOwnProperty(e) && void 0 !== t.style[e]) return s[e];
    };
    expand = () => {
      const e = ((t) => {
        t.target === this.content &&
          (this.content.removeEventListener(this.transitionendevent, e),
          this.isOpen &&
            requestAnimationFrame(() => {
              (this.content.style.transition = "0"),
                (this.content.style.height = "auto"),
                requestAnimationFrame(() => {
                  (this.content.style.height = null),
                    (this.content.style.transition = null),
                    this.setExpandedAria(),
                    this.classList.add(this.expandedClass),
                    this.trySetTabIndex(this.content, 0),
                    this.fire("tabOpened");
                });
            }));
      }).bind(this);
      this.content.addEventListener(this.transitionendevent, e),
        (this.isOpen = !0),
        this.classList.remove(this.collapsedClass),
        (this.content.style.height = this.content.scrollHeight + "px");
    };
    collapse = () => {
      const e = ((t) => {
        t.target === this.content &&
          (this.content.removeEventListener(this.transitionendevent, e),
          this.isOpen ||
            (this.fire("elementClosed"),
            this.setCollapsedAria(),
            this.classList.add(this.collapsedClass),
            this.trySetTabIndex(this.content, -1)));
      }).bind(this);
      this.content.addEventListener(this.transitionendevent, e),
        (this.isOpen = !1),
        this.classList.remove(this.expandedClass),
        requestAnimationFrame(() => {
          (this.content.style.transition = "0"),
            (this.content.style.height = this.content.scrollHeight + "px"),
            requestAnimationFrame(() => {
              (this.content.style.transition = null),
                (this.content.style.height = this.collapsedHeight);
            });
        });
    };
    open = () => {
      (this.selected = !0),
        this.fire("elementSelected"),
        this.expand(),
        this.setAttribute("open", !0);
    };
    close = () => {
      (this.selected = !1),
        this.fire("elementUnselected"),
        this.collapse(),
        this.removeAttribute("open");
    };
    toggle = (e) => {
      if ((e?.preventDefault(), this.selected)) this.close();
      else if ((this.open(), this.oneAtATime)) {
        const e = document.querySelectorAll("collapsible-tab"),
          t = this.closest("[data-first-level]");
        e.length &&
          e.forEach((e) => {
            e !== this && e.selected && t !== e && e.close();
          });
      }
    };
    trySetTabIndex(e, t) {
      const s = e.querySelectorAll(this.defaultElements);
      s &&
        s.forEach((e) => {
          e.setAttribute("tabindex", t);
        });
    }
    setExpandedAria = () => {
      this.trigger.setAttribute("aria-expanded", "true"),
        this.content.setAttribute("aria-hidden", "false");
    };
    setCollapsedAria = (e) => {
      this.trigger.setAttribute("aria-expanded", "false"),
        this.content.setAttribute("aria-hidden", "true");
    };
    attachEvents = () => {
      this.trigger.addEventListener("click", (e) => this.toggle(e));
    };
    setDefaultData = () => {
      (this.events = {
        elementSelected: [],
        tabOpened: [],
        elementUnselected: [],
        elementClosed: [],
      }),
        (this.transitionendevent = this.transitionendEventName()),
        (this.expandedClass = "is-expanded"),
        (this.collapsedClass = "is-collapsed"),
        (this.trigger = this.querySelector("[data-trigger]")),
        (this.content = this.querySelector("[data-content]")),
        (this.collapsedHeight = "0px"),
        (this.defaultElements = [
          "a",
          "button",
          "input:not(.focus-none)",
          "[data-trigger]",
        ]),
        (this.oneAtATime = !0),
        this.dataset.oneOpen &&
          (this.oneAtATime = "true" === this.dataset.oneOpen);
    };
    fire = (e) => {
      let t = this.events[e];
      for (let e = 0; e < t?.length; e++) t[e](this);
    };
    on = (e, t) => {
      this.events[e] && this.events[e].push(t);
    };
    destroy = () => {
      this.trigger.removeEventListener("click", (e) => this.toggle(e)),
        this.content.removeAttribute("aria-hidden"),
        (this.content.style.height = "auto"),
        this.classList.remove(this.expandedClass, this.collapsedClass),
        this.removeAttribute("open");
    };
  }
  customElements.define("collapsible-tab", e);
}
